var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sectionBox"},[_c('div',{staticClass:"alFitrBox langEn",class:_vm.lang == 'ar' ? 'langAr':''},[_c('p',{staticClass:"urlBtnBox",on:{"click":_vm.urlBtn}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }